import React from "react";
import { motion } from "framer-motion";
import { awards } from "../Data";

const AwardsSection=({desc="", heading=""})=>{
    return(
        <>
        <section className="awards-section container">

  {/* TOP */}

  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.2,
    }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.15,
        },
      },
    }}
  >

    <motion.h2
      className="section-heading"
      variants={{
        hidden: {
          opacity: 0,
          y: 40,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.9,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >
      { heading || "Accredited, Certified, and Award-Winning" }
    </motion.h2>

    <motion.p
      className="section-text"
      variants={{
        hidden: {
          opacity: 0,
          y: 45,
        },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          },
        },
      }}
    >
      { desc || "At LDL Settlement Services, our industry credentials reflect our unwavering commitment to precision and legal compliance. We are proud members of Australia’s leading property bodies and recognized innovators in digital settlements—giving you absolute confidence from contract to keys."}
    </motion.p>

  </motion.div>

  {/* GRID */}

  <motion.div
    className="awards-grid"
    initial="hidden"
    whileInView="visible"
    viewport={{
      once: true,
      amount: 0.12,
    }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.12,
        },
      },
    }}
  >

    {awards.map((item, i) => (

      <motion.div
        className="award-img"
        key={i}
        initial={{
          opacity: 0,
          y: 45,
          scale: 0.96,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
          scale: 1,
        }}
        transition={{
          duration: 0.85,
          delay: i * 0.1,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{
          once: true,
        }}
        whileHover={{
          y: -8,
          scale: 1.03,
        }}
      >

        <motion.img
          src={item.img}
          alt={`Accredited, Certified, and Award-Winning ${i+1} | LDL Settlement Services`}
          whileHover={{
            scale: 1.05,
          }}
          transition={{
            duration: 0.35,
          }}
        />

      </motion.div>

    ))}

  </motion.div>

</section>
        </>
    )
}
export default AwardsSection;